// Used on the data object from a useQuery hook.
// Returns the first value in data.
export const getFirstQueryResult = <T>(data?: Record<string, T>) =>
  Object.values(data || {})[0];

// Used on the data object from a mutation result.
// Returns the result from the first object in data.
export const getFirstMutationResult = <T>(
  responseData?: Record<string, { result: T }>,
) => Object.values(responseData || {})[0]?.result;
